import React from 'react';
import propTypes from 'prop-types';
import { Stack, Chip, Typography } from '@metarouter-private/mr-mui';
import DisabledRevisionWarning from 'app/shared/components/integrations/DisabledRevisionWarning';
import formatRevisionText from 'app/playbook-editor/overview/AssignedPipelinesTable/cells/formatRevisionText';

function DeployedRevisionCell({ stagedRevision, deployedRevision, disabled, revisionDisabled }) {
  const revisionText = formatRevisionText(deployedRevision);

  // special callout if deployedRevision is behind stagedRevision
  if (Number.isInteger(deployedRevision) && Number.isInteger(stagedRevision) && stagedRevision !== deployedRevision) {
    const revisionDiff = Math.abs(stagedRevision - deployedRevision);
    const revisionLag = stagedRevision > deployedRevision ? 'behind' : 'ahead';
    const revisionDiffText = `${revisionDiff} ${revisionLag}`;

    return (
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Typography variant="body2" component="span">
          {revisionText}
        </Typography>
        {revisionDisabled && <DisabledRevisionWarning />}
        {disabled && (
          <Typography variant="subtitle2" component="span">
            (Paused)
          </Typography>
        )}
        <Chip color="warning" size="small" variant="soft" label={revisionDiffText} />
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Typography variant="body2" component="span">
        {revisionText}
      </Typography>
      {revisionDisabled && <DisabledRevisionWarning />}
      {disabled && (
        <Typography variant="subtitle2" component="span">
          (Paused)
        </Typography>
      )}
    </Stack>
  );
}

DeployedRevisionCell.propTypes = {
  stagedRevision: propTypes.number,
  deployedRevision: propTypes.number,
  disabled: propTypes.bool,
  revisionDisabled: propTypes.bool,
};

export default DeployedRevisionCell;
